import { enums } from "common/enums";
import { AsyncResult } from "common/types";

export function toAsyncResult<T>(action: PromiseLike<T>): Promise<AsyncResult<T>> {
  let _resolve!: (value: AsyncResult<T> | PromiseLike<AsyncResult<T>>) => void;

  const defer = new Promise<AsyncResult<T>>((resolve) => {
    _resolve = resolve;
  });

  action.then(
    (value) => {
      _resolve({
        status: enums.AsyncResultStatus.Succeeded, // поле status определено по-разному: для Office - это число, для Outlook - строка
        value: value,
      } as any);
    },
    (error) => {
      _resolve({
        status: enums.AsyncResultStatus.Failed, // поле status определено по-разному: для Office - это число, для Outlook - строка
        error: error,
      } as any);
    }
  );

  return defer;
}

export class Deferred<T = void> {
  resolve!: (value: T | PromiseLike<T>) => void;
  reject!: (reason?: any) => void;
  readonly promise: Promise<T>;

  constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

/**
 * Преобразовать параметры в фиксированный tuple [options, callback],
 * с учетом, что options может быть не задан, и тогда считаем,
 * что первый параметр - это callback.
 * @param options - опции или callback
 * @param callback - callback, когда заданы options
 */
export function extract(options: any, callback?: any) {
  if (callback) {
    return [options, callback];
  }

  return [{}, options];
}
